export default __webpack_public_path__ + "static/media/48.38b4974c.png";